// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2QZnk","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1ak4X"};